module.exports = __webpack_public_path__ + "img/meatbox.187748ca.png";